import { render } from "./AlertDeleteProductModal.vue?vue&type=template&id=51e18420"
import script from "./AlertDeleteProductModal.vue?vue&type=script&lang=js"
export * from "./AlertDeleteProductModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__